function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1474_17299)",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.604 4.001a.76.76 0 00-.463.228l-.612.62a.76.76 0 101.082 1.07l.106-.11a.911.911 0 01.648-.27h2.007a1 1 0 01.711.297l.107.108a1 1 0 01.289.703v.875a1 1 0 01-.547.891L8.852 9.47a.768.768 0 00-.416.685v.778c0 .42.34.76.76.76h.106a.655.655 0 00.656-.655c0-.247.138-.472.358-.584L12.584 9.3A.767.767 0 0013 8.616V5.924a.775.775 0 00-.226-.54l-1.14-1.155a.758.758 0 00-.536-.228H7.676a.562.562 0 00-.072 0zm1.593 8.46a.76.76 0 00-.76.761v.017a.76.76 0 101.521 0v-.017a.76.76 0 00-.761-.76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.25 0c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9zm0 1.5c4.151 0 7.5 3.349 7.5 7.5s-3.349 7.5-7.5 7.5A7.489 7.489 0 011.75 9c0-4.151 3.349-7.5 7.5-7.5z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1474_17299"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.25)",
  d: "M0 0h18v18H0z"
})))));